import React, { useState } from 'react';
import Modal from '../../../../../../components/Modal';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import AddCollaboratorsModal from '../../../../components/assignmentFloatingMenu/modals/AddCollaboratorsModal';
import { faUserEdit } from '@fortawesome/pro-solid-svg-icons';
import AddCoTeacher from '../../../../../classes/components/addCoteacher';
import Skeleton from 'react-loading-skeleton';
import NoAssignment from '../../../../../../assets/images/NoAssignment.png';

const ViewCoTeachersModal = ({ modalData, onClose, setModalData, fromMoreActions , coteachers ,setCoteachers, coTeachersDataLoading, isClassCoTeacher, isDistrictManaged }) => { 
  const [addColloboratorsModal, setAddColloboratorsModal] = useState(false);
  const hasAllowEdit = coteachers?.some(coteacher => coteacher.allowEdit);
  
  return (
    <>
      <Modal
        contentWidth="700px"
        isOpen={modalData}
        titleName={ isClassCoTeacher? 'View/Add Co-Teachers' : 'Assignment Collaborators'}
        titleToolTip={isClassCoTeacher? 'Co-teachers will have access to all of your assignments by default,</br> unless turned off for a specific assignment.' : null}
        onClose={() => {onClose();setCoteachers([]);}}
      >
        {!coTeachersDataLoading && coteachers?.length > 0 && <>
          <div className='container collaborators-list'>
            <div className='row'>
              {coteachers.map((item) => (
                <div key={item.id} className='my-2 col-6'>
                  <div className='box-background d-flex align-items-baseline custom-p-tag'>
                    <p className='me-auto'>{item.name}</p>
                    {item.allowEdit && <FontAwesomeIcon icon={faUserEdit} style={{ color: '#82A9E2' }} /> }
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
        }
        {!coTeachersDataLoading && (!coteachers || coteachers?.length==0) &&
          <div className="no-assignments-card">
            <div className="text-center no-assignments-icon">
              <img src={NoAssignment} className="my-4" />
              {isClassCoTeacher && <p className="mx-5">
                The class does not have any co-teachers, You can add co-teachers by clicking on the <b>Add button</b>
              </p>}
              {!isClassCoTeacher && <p className="mx-5">
                The assignment does not have any collaborators, You can add collaborators by clicking on the <b>Add button</b>
              </p>}
            </div>
          </div>
        }
        {coTeachersDataLoading && <>
          <div><Skeleton /></div>
          <div><Skeleton /></div>
          <div><Skeleton /></div>
        </>
        }
        {hasAllowEdit && <div className='d-flex py-4'>
          <FontAwesomeIcon icon={faUserEdit} style={{ color: '#82A9E2' }} /><div>&nbsp;<span>Means co-teacher has class editing rights</span></div>
        </div> }
        
        {!isClassCoTeacher && 
          <div className='addcollaborators mt-2'>
            <div className='mt-4'
              onClick={() => setAddColloboratorsModal(true)}>
              <FontAwesomeIcon className='box-background' icon={faPlus} style={{ color: '#82A9E2' }} />
              <div>Add/Edit Collaborators to this Assignment</div>
            </div>
          </div>
        }
        
        {isClassCoTeacher && !isDistrictManaged &&
          <div className='addcollaborators mt-2'>
            <div className='mt-4'
              onClick={() => setAddColloboratorsModal(true)}>
              <FontAwesomeIcon className='box-background' icon={faPlus} style={{ color: '#82A9E2' }} />
              <div>Add/Edit Co-Teachers</div>
            </div>
          </div>
        }
      </Modal>
      {!isClassCoTeacher && addColloboratorsModal && (
        <AddCollaboratorsModal
          modalData={addColloboratorsModal}
          setModalData={setAddColloboratorsModal}
          setCoteacherModel={setModalData}
          setUpdatedCoTeachers={setCoteachers}
          fromMoreActions={fromMoreActions}
        />)}

      {isClassCoTeacher && addColloboratorsModal && (
        <AddCoTeacher
          isOpen={addColloboratorsModal} 
          onClose={()=>setAddColloboratorsModal(false)}
          coTeachers={coteachers}
          setCoTeachers={setCoteachers}          
        />)}
    </>
  );
};

ViewCoTeachersModal.propTypes = {
  modalData: PropTypes.bool,
  onClose: PropTypes.func,
  setModalData: PropTypes.func,
  fromMoreActions: PropTypes.bool,
  coteachers : PropTypes.array,
  setCoteachers: PropTypes.func,
  coTeachersDataLoading: PropTypes.bool,
  isClassCoTeacher: PropTypes.bool,
  isDistrictManaged: PropTypes.bool
};

export default ViewCoTeachersModal;
